<template>
    <v-card flat class="sub-site-wrapper">
        <div class="chart-component-wrapper">
            <div class="statistics-meta">
                <p>Leads gesamt: {{ totalLeads }}</p>
                <p>Datensatz erstellt am: {{ statisticsAge }}</p>
                <p>Verschiedene Quellen: {{ differentSources }}</p>
            </div>
            <div class="chart-controls">
                <v-btn-toggle variant="outlined" rounded="lg" v-model="chartType">
                    <v-btn value="bar">Bar</v-btn>
                    <v-btn value="line">Line</v-btn>
                    <v-btn value="area">Area</v-btn>
                    <v-btn value="pie">Pie</v-btn>
                </v-btn-toggle>
            </div>
            <div class="charts-wrapper">
                <apexchart v-if="!loading" :key="chartType" :type="chartType" height="400" :options="chartOptions"
                    :series="chartSeries">
                </apexchart>
                <p v-else>Loading...</p>
            </div>
        </div>
    </v-card>
</template>

<script>

import { mapState } from 'vuex';
import VueApexCharts from 'vue3-apexcharts';

export default ({

    components: {
        apexchart: VueApexCharts
    },
    data() {
        return {
            chartType: 'bar'  // Default chart type
        };
    },
    computed: {
        ...mapState('statistics', ['sourceOfLeadsPast30Days', 'loading', 'statisticsAge']),
        sortedSourceOfLeadsPast30Days() {
            // Sort by count in descending order
            if (!this.sourceOfLeadsPast30Days) return [];
            return [...this.sourceOfLeadsPast30Days].sort((a, b) => b.count - a.count);
        },
        totalLeads() {
            // Calculate the total number of leads by summing the count of each source
            return this.sortedSourceOfLeadsPast30Days.reduce((total, source) => total + source.count, 0);
        },
        differentSources() {
            // The number of different sources is just the length of the sourceOfLeads array
            return this.sortedSourceOfLeadsPast30Days.length;
        },
        chartSeries() {
            // Handle series format for pie chart separately
            return this.chartType === 'pie'
                ? this.sortedSourceOfLeadsPast30Days.map(item => item.count)
                : [{
                    name: 'Count',
                    data: this.sortedSourceOfLeadsPast30Days.map(item => item.count)
                }];
        },
        chartOptions() {
            return {
                chart: {
                    type: this.chartType  // Use dynamic chart type
                },
                colors: this.chartType === 'pie' ? ['#783597', '#FF5733', '#C70039', '#900C3F', '#581845', '#FFC300', '#DAF7A6', '#FF5733', '#C70039', '#900C3F', '#581845', '#56BAEC', '#B6D7F2', '#8A2BE2', '#7FFF00', '#D2691E'] : ['#783597'],
                xaxis: this.chartType !== 'pie' ? {
                    categories: this.sortedSourceOfLeadsPast30Days.map(item => item.source)
                } : undefined,
                labels: this.chartType === 'pie' ? this.sortedSourceOfLeadsPast30Days.map(item => item.source) : [],
                plotOptions: {
                    bar: {
                        horizontal: false,
                    }
                },
                dataLabels: {
                    enabled: false
                },
                title: {
                    text: 'Lead Source letzte 30 Tage',
                    align: 'center'
                }
            };
        }
    }
});
</script>

<style scoped>
.chart-controls {
    display: flex;
    justify-content: center;
    margin: 20px auto;
}

.chart-component-wrapper {
    background-color: white;
    margin: 12px 0;
    padding: 12px;
    border-radius: 12px;
}
</style>